import React from 'react';
import ModalNotification from '~/components/ui/ModalNotification';

function AlertBillExample(props) {
  return (
    <ModalNotification>
      <div className="text-center my-5 my-md-0 ModalRenewal">
        <nav>
          <button
            type="button"
            className="red-color btn-close btn-cloce-bill"
            onClick={props.close}
          >
            <span>
              <i className="fas fa-times-circle fa-2x" />
            </span>
          </button>
        </nav>
        <div className="modalGen">
          <div className="modalGenWrap">
            <div className="modalNotify">
              <p dangerouslySetInnerHTML={{ __html: props.descriptionBilling }} />
              <div className="image-bill-example">
                <div className="image-bill">
                  <a href={props.imageBilling} target="_blank" rel="noreferrer">
                    <img
                      loading="lazy"
                      alt="imagen de ejemplo de una factura"
                      src={props.imageBilling}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalNotification>
  );
}

export default AlertBillExample;
